import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX, ActionOverRecordTypes, IActionsSchema, triggerAction, ZendraLocalizationServices } from '@zendra/shared';
import {
  CycleProjectionPlanningOrchestratorService,
  RotationProjectionPlanningOrchestratorService,
} from 'orchestrator';
import { CostReceiverService, GeneticMaterialService, PackingTypeService, PlantationTypeService, PropertyService, SeedlingOriginService, SpacingService, StandService, LocationService } from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

export const PLANTATION_FIELDS: FieldDefinition[] = [
  FieldBuilder.number('plantationId', 'Entity.Plantation.PlantationId')
    .readOnly()
    .build(),
  FieldBuilder
    .date('plantationDate', 'Entity.Plantation.PlantationDate')
    .required()
    .build(),
  FieldBuilder
    .number('plantationArea', 'Entity.Plantation.PlantationArea')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('plantedSeedlings', 'Entity.Plantation.PlantedSeedlings')
    .required()
    .build(),
  FieldBuilder
    .checkbox('isPlantationCompleted', 'Entity.Plantation.IsPlantationCompleted')
    .build(),
  FieldBuilder
    .checkbox('isOwnPlantation', 'Entity.Plantation.IsOwnPlantation')
    .build(),
  FieldBuilder
    .date('processedDate', 'Entity.Plantation.ProcessedDate')
    .build(),
  FieldBuilder.foreignKey(
    'rotationId',
    'Entity.Rotation',
    RotationProjectionPlanningOrchestratorService
  )
    .required()
    .display('rotationDisplay')
    .displayFromNested('rotationValue')
    .sortBy('rotationValue')
    .build(),
  FieldBuilder.foreignKey('cycleId', 'Entity.Cycle', CycleProjectionPlanningOrchestratorService)
    .display('cycleDisplay')
    .displayFromNested('cycleValue')
    .sortBy('cycleValue')
    .readOnly()
    .build(),
  FieldBuilder
    .foreignKey('standId', 'Entity.Stand', StandService)
    .display('name')
    .displayFromNested('standName')
    .sortBy('standName')
    .readOnly()
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .prefilter({ multiple: true })
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('locationId', 'Entity.Location', LocationService)
    .display('name')
    .displayFromNested('locationName')
    .sortBy('locationName')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('costReceiverId', 'Entity.CostReceiver', CostReceiverService)
    .display('name')
    .displayFromNested('costReceiverName')
    .sortBy('costReceiverName')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'geneticMaterialId',
    'Entity.GeneticMaterial',
    GeneticMaterialService
  )
    .required()
    .display('name')
    .displayFromNested('geneticMaterialName')
    .sortBy('geneticMaterialName')
    .build(),
  FieldBuilder.foreignKey(
    'spacingId',
    'Entity.Spacing',
    SpacingService
  )
    .required()
    .display('name')
    .displayFromNested('spacingName')
    .sortBy('spacingName')
    .build(),
  FieldBuilder.foreignKey(
    'plantationTypeId',
    'Entity.PlantationType',
    PlantationTypeService
  )
    .required()
    .display('name')
    .displayFromNested('plantationTypeName')
    .sortBy('plantationTypeName')
    .build(),
  FieldBuilder.foreignKey(
    'seedlingOriginId',
    'Entity.SeedlingOrigin',
    SeedlingOriginService
  )
    .display('name')
    .displayFromNested('seedlingOriginName')
    .sortBy('seedlingOriginName')
    .build(),
  FieldBuilder.foreignKey(
    'packingTypeId',
    'Entity.PackingType',
    PackingTypeService
  )
    .display('name')
    .displayFromNested('packingTypeName')
    .sortBy('packingTypeName')
    .build(),
];

const namespace = ZendraLocalizationServices.Geographic;

export const PLANTATION_ACTION_IDS = {
  processPlantationTrigger: 0,
  undoProcessPlantationTrigger: 1,
};

export const PLANTATION_ACTIONS_CONFIG: IActionsSchema = {
  multipleRecord: [
    triggerAction(
      PLANTATION_ACTION_IDS.processPlantationTrigger,
      'Action.Trigger.ProcessPlantation',
      ActionOverRecordTypes.MultipleRecord,
      namespace,
    ),
    triggerAction(
      PLANTATION_ACTION_IDS.undoProcessPlantationTrigger,
      'Action.Trigger.UndoProcessPlantation',
      ActionOverRecordTypes.MultipleRecord,
      namespace,
    ),
  ],
};

export const PLANTATION_CONFIG = {
  entityName: 'Plantation',
  localizationKey: 'Geographic::Entity.Plantation',
  fields: PLANTATION_FIELDS,
  permission: 'PlanningGeography.Plantations',
  actions: PLANTATION_ACTIONS_CONFIG,
  actionIds: PLANTATION_ACTION_IDS,
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsPlanning + MENU_NAME_SUFFIX,
};
